import util from "../../../util/util";
import {
  PREPARE_TOUR_TYPE_REGIONAL,
  PREPARE_TOUR_TYPE_FIX
} from "../../../util/enumTypes";

export default {
  components: {},
  props: {
    tourType: String,
    titile: String,
    pdf: {
      type: String,
      default: ""
    },
    photos: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      carouselIndex: 0
    };
  },
  computed: {
    caruselType() {
      if (util.getWidthWindow() <= 778) {
        return null;
      }
      return "card";
    },
    isFIXTour() {
      return this.tourType == PREPARE_TOUR_TYPE_FIX;
    },
    isRegionalTour() {
      return this.tourType == PREPARE_TOUR_TYPE_REGIONAL;
    }
  },
  methods: {
    setActiveItem(val) {
      console.log("setActiveItem", val);
      this.carouselIndex = val;
    },
    getPdf() {
      this.$emit("getPdf");
    },
    sendEmail() {
      this.$emit("sendEmail");
    }
  }
};
